import React,{useRef,useEffect} from 'react';   
import { Step } from 'semantic-ui-react';
import {
    Button,
    Container,
    Divider,
    Dropdown,
    Grid,
    Header,
    Icon,
    Image,
    List,
    Menu,
    Responsive,
    Segment,
    Sidebar,
    Visibility,
    Input,
  } from 'semantic-ui-react';
  import LazyLoad from 'react-lazy-load';
  import axios from 'axios';

  class SupportPage extends React.Component {


    constructor(props) {
        super(props); 
        this.state = { emailAddress:"" }; 
        this.input = React.createRef();
      }
        
    render()
    {   
        var onChange = e=>{this.setState({emailAddress:e.target.value})};
        var signup = <div>
            <Input  size='mini' onChange={onChange} placeholder="email address" ref={(input) => this.input = input} ></Input>
            <Button compact basic color="blue" size={'tiny'} onClick={e=>this.registerEmail()} >submit </Button>
        </div>

        return <div> 
            <LazyLoad  height={75}><div></div></LazyLoad>  
            
            
            <Container text> 
            <Header inverted as='h3' color='blue'  style={{fontSize:'2em'}}>
            <Icon name='patreon'/>
                Support the game 
            </Header>
            Support the project with 
                <a href="https://www.patreon.com/cascadetactics"> <Button compact basic color="blue" size={'tiny'}>Patreon </Button> </a>
            </Container>
            <Divider></Divider>
            <Container text>
            <Header inverted as='h3' color='blue'  style={{fontSize:'2em'}}>
            <Icon name='mail'/>
                Sign up to the mailing list
            </Header>
                Those on the mailing list will get updates on the game and the first chance to play the beta-version. {signup}
            </Container>
            <Divider></Divider>
            <Container text>
            <Header inverted as='h3' color='blue'  style={{fontSize:'2em'}}>
            <Icon name='heart'/>
                Send encouraging words
            </Header>
                MythicMachineSoftware@gmail.com
            </Container>
            <Divider></Divider>
            <Container text>
            <Header inverted as='h3' color='blue'  style={{fontSize:'2em'}}>
            <Icon name='user'/>
                Tell a friend
            </Header> 
            The easiest way to help is to just tell your friends
            </Container>
            <Divider></Divider> 
            <Container text>
            <Header inverted as='h3' color='blue'  style={{fontSize:'2em'}}>
            <Icon name='twitter'/>
                Follow on Twitter
            </Header>
            Get more details, gifs, and answers to questions on
                <a href="https://twitter.com/CascadeTactics"> <Button compact basic color="blue" size={'tiny'}>Twitter </Button> </a>
            </Container> 
            <LazyLoad  height={850}><div></div></LazyLoad>  
        </div>
    }

    registerEmail()
    { 
        
        axios.post("https://qqmf5t43p9.execute-api.us-east-1.amazonaws.com/dev/mailinglist",{email:this.state.emailAddress}).then(result=>{ 
            this.input.inputRef.current.value = ""
        });
    }


}
export default SupportPage